import { createFileRoute } from '@tanstack/react-router'

import { NewClientPage } from '@/pages/clients/new/NewClientPage'

export const Route = createFileRoute('/_authenticated/_dashboard/clients/new/')({
  component: NewClientPage,
})
